var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-display"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.formattedTime))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.formattedDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }